import { Loader, SofiaMark } from "@coval/ui"
import { Check } from "lucide-react"

import { reportClass } from "./ReportStyles"

export function LoadingDocument({ action }: { action: string }) {
  return (
    <div className={reportClass("loading-document")} role="status">
      <SofiaMark size={64} animated />
      <div className={reportClass("eyebrow")}>SOFIA IS WORKING</div>
      <h2>
        {action === "Generating notebook"
          ? "Turning the week into a story."
          : `${action}…`}
      </h2>
      <p>
        Using the selected scope and verified data to compose a notebook you can
        question, edit, and save.
      </p>
      <div className={reportClass("loading-steps")}>
        <span>
          <Check size={14} />
          Scope and period selected
        </span>
        <span>
          <Loader size="sm" aria-hidden="true" />
          Working with the data
        </span>
        <span>Preparing your notebook</span>
      </div>
      <p className={reportClass("field-hint")}>
        Generation can take a minute or two. Keep this page open.
      </p>
    </div>
  )
}
